module.exports = __webpack_public_path__ + "489ba8b8198327f804f80f49f0c6e68c.png";